/* eslint-disable no-restricted-properties */
const ONE_DAY_MILLISECONDS = 1000 * 60 * 60 * 24;


/*
 * Annualized Returns Service
 *
 * Formula:
 *
 * (( end period value / start period value ) ** ( 365 / days in period ) - 1) * 100
 *
 *
 * Normalized:
 *
 * startVal = 1
 * endVal = (percentChange / 100) + 1
 */
export class AnnualizedReturnsService {
    static daysBetween(startDate, endDate) {
        return Math.round((endDate - startDate) / ONE_DAY_MILLISECONDS);
    }

    static annualizeReturns(startDate, startVal, endDate, endVal) {
        // If either values are < 0 do not annualize
        if (startVal < 0 || endVal < 0) return NaN;
        const daysBetween = this.daysBetween(startDate, endDate);
        return (((Math.pow((endVal / startVal), (365 / daysBetween)) - 1)) * 100).toFixed(2);
    }

    static annualizeNormalizedReturns(startDate, percentChange, endDate) {
        const startVal = 1;
        const endVal = (percentChange / 100) + 1;
        return this.annualizeReturns(startDate, startVal, endDate, endVal);
    }
}
